import React from "react";
import { Box, Dialog, SwipeableDrawer, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

// Ver TAREA: ayuda contextual del CRM. El CRM no tenía un shell
// responsivo extraído -- cada pantalla repite `isMobile ? Drawer :
// Dialog` por su cuenta. Se extrae ACÁ, ahora, porque AyudaContextualSheet
// lo necesita de todas formas y separarlo en su propio archivo cuesta lo
// mismo que dejarlo inline -- mismo criterio que Citas usó al introducir
// este mismo componente (ResponsiveSheet.jsx): se extrae para el
// consumidor nuevo, sin migrar retroactivamente los `isMobile ? Drawer :
// Dialog` que ya viven copiados en otras pantallas del CRM (deuda
// pendiente aparte, no bundleada en esta tarea).
export default function ResponsiveSheet({
  open, onClose, children,
  maxHeightMobile = "90vh", desktopWidth = 460, zIndex = 1301,
}) {
  const theme = useTheme();
  const isLight = theme.palette.mode === "light";
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const paperBg = theme.palette.background.paper;

  if (isMobile) {
    return (
      <SwipeableDrawer
        anchor="bottom" open={open} onOpen={() => {}} onClose={onClose}
        disableSwipeToOpen disableAutoFocus
        BackdropProps={{ sx: { backgroundColor: "rgba(0,0,0,0.6)" } }}
        PaperProps={{ sx: { borderRadius: "22px 22px 0 0", background: paperBg, maxHeight: maxHeightMobile, display: "flex", flexDirection: "column" } }}
        sx={{ zIndex }}
      >
        <Box sx={{ width: 36, height: 4, background: isLight ? "rgba(0,0,0,0.1)" : "rgba(255,255,255,0.15)", borderRadius: 2, mx: "auto", mt: "10px", mb: "10px", flexShrink: 0 }} />
        {children}
      </SwipeableDrawer>
    );
  }

  return (
    <Dialog
      open={open} onClose={onClose} maxWidth="xs" fullWidth disableAutoFocus
      sx={{ zIndex }}
      PaperProps={{ sx: { borderRadius: "16px", background: paperBg, width: desktopWidth } }}
    >
      {children}
    </Dialog>
  );
}
